import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import _ from "underscore";
import axios from "axios";

class GlobalUnitService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    getUnits({inn}) {
        return Vue.axios.get(`${API_HOST}/api/GlobalUnit`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: typeof (inn) === 'string' ? inn : null
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getUserUnits({inn}) {
        return Vue.axios.get(`${API_HOST}/api/GlobalUserUnit`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: typeof (inn) === 'string' ? inn : null
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    checkUnit(unit) {
        return Vue.axios.get(`${API_HOST}/api/CheckGlobalUnit`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                name: unit
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    addUnit({unitName, organizationInn , address, region}) {
        return Vue.axios.post(`${API_HOST}/api/GlobalUnit`, {
            Name: unitName,
            GlobalOrganizationInn: organizationInn,
            Address: address,
            Regions: _.map(region, r => {
                return r.id
            })
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    editUnit({id, unitName, organizationInn, isHead, address, region}) {
        return Vue.axios.put(`${API_HOST}/api/GlobalUnit`, {
            Name: unitName,
            GlobalOrganizationInn: organizationInn,
            IsHead: isHead,
            Address: address,
            Regions: _.map(region, r => {
                return r.id
            })
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id
            }
        })
    }
}

export default new GlobalUnitService()
